import { render, staticRenderFns } from "./BlogArticleItemPage.vue?vue&type=template&id=05c46690&"
import script from "./BlogArticleItemPage.vue?vue&type=script&lang=js&"
export * from "./BlogArticleItemPage.vue?vue&type=script&lang=js&"
import style0 from "./BlogArticleItemPage.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports